import { useTranslation } from 'next-i18next';

import { BreadCrumbSp } from '../BreadCrumbSp';
import { PageTitleSp } from '../PageTitleSp';
import { PrivacyPolicyContent } from './PrivacyPolicy';

export const PrivacyPolicyContentSp = () => {
  const { t } = useTranslation('common');

  return (
    <>
      <meta charSet="utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>3 - プライバシーポリシー</title>
  
      <div 
      style={{
        height: 'auto',
        backgroundColor: '#fff',
        paddingBottom: '1320px',
        cursor: 'auto',
      }}
      >
        <PageTitleSp
            {...{ main: t('Privacy Policy'), sub: t('プライバシーポリシー') }}
          />
          <BreadCrumbSp />
        <div className="relative">
          <div className="mx-auto max-w-[1536px] px-10 pb-40 pt-32 md:px-32 md:pb-60 md:pt-20">
            <div className="mx-auto max-w-4xl">
              <section className="mb-16 md:mb-24">
                <h2 className="mb-8 text-5xl text-center md:text-5xl " style={{ fontFamily: 'Zen Old Mincho' }}>
                  {t('個人情報保護方針')}
                </h2>
                <p className="text-3xl leading-relaxed md:text-lg">
                  {t(
                    '本ウェブサイトは、税理士法人奏共同会計事務所（以下「当社」）の事業内容等を紹介するサイトです。'
                  )}
                </p>
              </section>
    
              <section className="mb-16 md:mb-24">
                <h3 className="mb-6 text-4xl" style={{ fontFamily: 'Zen Old Mincho' }} >
                  {t('個人情報保護方針')}
                </h3>
                <p className="text-3xl leading-relaxed md:text-lg">
                  {t(
                    '当社は、以下のとおり個人情報保護方針を定め、個人情報保護の仕組みを構築し、全従業員に個人情報保護の重要性の認識と取組みを徹底させることにより、個人情報の保護を推進致します。'
                  )}
                </p>
              </section>
    
              <section className="mb-16 md:mb-24">
                <h3 className="mb-6 text-4xl" style={{ fontFamily: 'Zen Old Mincho' }} >
                  {t('個人情報の管理')}
                </h3>
                <p className="text-3xl leading-relaxed md:text-lg">
                  {t(
                    '当社は、お客さまの個人情報を正確かつ最新の状態に保ち、個人情報への不正アクセス・紛失・破損・改ざん・漏洩などを防止するため、セキュリティシステムの維持・管理体制の整備・社員教育の徹底等の必要な措置を講じ、安全対策を実施し個人情報の厳重な管理を行ないます。'
                  )}
                </p>
              </section>

              <section className="mb-16 md:mb-24">
                <h3 className="mb-6 text-4xl" style={{ fontFamily: 'Zen Old Mincho' }} >
                  {t('個人情報の利用目的')}
                </h3>
                <p className="text-3xl leading-relaxed md:text-lg">
                  {t(
                    '本ウェブサイトでは、お客様からのお問い合わせ時に、お名前、e-mailアドレス、電話番号等の個人情報をご登録いただく場合がございますが、これらの個人情報はご提供いただく際の目的以外では利用いたしません。お客さまからお預かりした個人情報は、当社からのご連絡や業務のご案内やご質問に対する回答として、電子メールや資料のご送付に利用いたします。'
                  )}
                </p>
              </section>
    
              <section className="mb-16 md:mb-24">
                  <h3 className="mb-6 text-4xl" style={{ fontFamily: 'Zen Old Mincho' }}>
                  {t('個人情報の第三者への開示・提供の禁止')}
                </h3>
                <p className="mb-6 text-3xl leading-relaxed md:text-lg">
                  {t('当社は、お客さまよりお預かりした個人情報を適切に管理し、次のいずれかに該当する場合を除き、個人情報を第三者に開示いたしません。')}
                </p>
                <ul className="list-inside list-disc text-3xl leading-relaxed md:text-lg">
                  <li className="mb-3">{t('お客さまの同意がある場合')}</li>
                  <li className="mb-3">{t('お客さまが希望されるサービスを行なうために当社が業務を委託する業者に対して開示する場合')}</li>
                  <li className="mb-3">{t('法令に基づき開示することが必要である場合')}</li>
                </ul>
              </section>

              <section className="mb-16 md:mb-24">
                  <h3 className="mb-6 text-4xl" style={{ fontFamily: 'Zen Old Mincho' }}>
                  {t('個人情報の安全対策')}
                </h3>
                <p className="text-3xl leading-relaxed md:text-lg">
                  {t(
                    '当Webサイトは、個人情報登録の際に、SSL等の暗号化技術を使い安全性の確保に努めます。'
                  )}
                </p>
              </section>
    

              <section className="mb-16 md:mb-24">
                <h3 className="mb-6 text-4xl" style={{ fontFamily: 'Zen Old Mincho' }}>
                  {t('ご本人の照会')}
                </h3>
                <p className="text-3xl leading-relaxed md:text-lg">
                  {t(
                    'お客さまがご本人の個人情報の照会・修正・削除などをご希望される場合には、ご本人であることを確認の上、対応させていただきます。'
                  )}
                </p>
              </section>

              <section className="mb-16 md:mb-24">
                <h3 className="mb-6 text-4xl" style={{ fontFamily: 'Zen Old Mincho' }}>
                  {t('法令、規範の遵守と見直し')}
                </h3>
                <p className="text-3xl leading-relaxed md:text-lg">
                  {t(
                    '当社は、保有する個人情報に関して適用される日本の法令、その他規範を遵守するとともに、本ポリシーの内容を適宜見直し、その改善に努めます。'
                  )}
                </p>
              </section>

              <section className="mb-16 md:mb-24">
                <h3 className="mb-6 text-4xl" style={{ fontFamily: 'Zen Old Mincho' }}>
                  {t('Cookieについて')}
                </h3>
                <p className="text-3xl leading-relaxed md:text-lg">
                  {t(
                    '当サイトでは、一部のコンテンツについてCookieを利用しています。Cookieとは、サイトにアクセスした際にブラウザに保存される情報で、名前やメールアドレスなどの個人情報は含みません。当サイトにアクセスいただいた方に効果的な広告を配信するため、またアクセス解析にCookieを利用する場合があります。ブラウザの設定により、Cookieを使用しないようにすることもできます。'
                  )}
                </p>
              </section>
    

              <section>
                <h3 className="mb-6 text-4xl" style={{ fontFamily: 'Zen Old Mincho' }}>
                  {t('お問い合せ')}
                </h3>
                <p className="mb-6 text-3xl leading-relaxed md:text-lg">
                  {t(
                    '当社の個人情報の取扱に関するお問い合せは下記までご連絡ください。'
                  )}
                </p>
                <div className="text-3xl leading-relaxed md:text-lg">
                  {t('税理士法人奏共同会計事務所')}
                  <br />
                  {t('〒420-0837 静岡県静岡市葵区日出町1-2 TOKAI日出町ビル7階')}
                  <br />
                  {t('お問い合わせ：info@kanade-consulting.or.jp')}
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicyContent; 